module.exports = __webpack_public_path__ + "static/media/settlement_nav.5d5e91ef.svg";